import type { ButtonHTMLAttributes, ReactNode } from "react";

type ButtonVariant = "primary" | "secondary" | "ghost" | "danger";

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  children: ReactNode;
  variant?: ButtonVariant;
  fullWidth?: boolean;
  isLoading?: boolean;
};

const variants: Record<ButtonVariant, string> = {
  primary:
    "bg-ink text-white hover:bg-graphite focus-visible:ring-ink disabled:bg-graphite/40",
  secondary:
    "border border-line bg-field text-ink hover:border-graphite/40 hover:bg-white focus-visible:ring-graphite",
  ghost:
    "bg-transparent text-graphite hover:bg-ink/5 focus-visible:ring-graphite",
  danger:
    "bg-red-900 text-white hover:bg-red-950 focus-visible:ring-red-900 disabled:bg-red-900/40",
};

export function Button({
  children,
  className = "",
  disabled,
  fullWidth = false,
  isLoading = false,
  type = "button",
  variant = "primary",
  ...props
}: ButtonProps) {
  return (
    <button
      className={[
        "inline-flex min-h-11 items-center justify-center rounded-md px-4 py-2.5 text-sm font-semibold transition focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-paper",
        variants[variant],
        fullWidth ? "w-full" : "",
        disabled || isLoading ? "cursor-not-allowed opacity-80" : "",
        className,
      ].join(" ")}
      disabled={disabled || isLoading}
      type={type}
      {...props}
    >
      {isLoading ? "Please wait" : children}
    </button>
  );
}
